import type { PageBuilderModuleType } from '~/modules/page-builder/types';
import type { ModulesWithAds, ProjectAd } from '~/modules/adverts/type';

const getModuleWithAds = (
    modules: PageBuilderModuleType[],
    ads: ProjectAd[],
    maxAds: number, // at most `maxAds` ads
    adGap: number, // insert ads after every `adGap` modules
): ModulesWithAds => {
    let adsIndex = 0;
    adGap = Math.max(adGap, 1);

    // Insert ads into the module array at the calculated indexes
    const modulesWithAds = modules.reduce(
        (list: ModulesWithAds, elem: PageBuilderModuleType, i) => {
            list.push(elem);
            // Insert ads after every `adGap` modules
            if (i % adGap === adGap - 1) {
                const ad = ads[adsIndex];
                if (adsIndex < maxAds && ad) {
                    list.push({
                        presetType: 'ads',
                        ad,
                        id: ad.id,
                    });
                    adsIndex++;
                }
            }
            return list;
        },
        [],
    );

    return modulesWithAds;
};

export default getModuleWithAds;
